import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

interface PublicRouteProps {
  element: JSX.Element;
  restricted?: boolean;
}

const PublicRoute = ({ element, restricted = false }: PublicRouteProps) => {
  const { user } = useSelector((state: RootState) => state.auth);

  if (user && restricted) {
    // If logged in and trying to access a restricted route, redirect to home
    return <Navigate to="/" replace />;
  }

  return element;
};

export default PublicRoute;